import React from 'react'

import { Link } from 'react-router-dom'

import classes from './how-to-complain.module.scss'
import { Accordion } from '../accordion'
import ContentWrapper from '../content-wrapper'

interface HowToComplainProps {
  link?: string
  isFullWidthBox?: boolean
}

/**
 * ADR (Alternative dispute resolution) accordion
 * Figma - https://www.figma.com/design/w0fCpG0jR7ziOvFxyOZvt8/ADR?node-id=13-61&t=A9FGwyWqHWrjP7Pp-0
 * */

export const HowToComplain = ({ link, isFullWidthBox }: HowToComplainProps) => {
  const pageLink = link || '/complaints'

  const AccordionContent = () => (
    <Accordion
      title="How to complain"
      type="inset-shaded"
      className={classes.accordionWrapper}
    >
      <>
        You can view our complaints code, including the process and timescales
        for investigating your complaint, at{' '}
        <Link to={pageLink}>SMARTY.co.uk{pageLink}</Link>
        . If your complaint isn&apos;t resolved after 8 weeks, or you&apos;re
        not happy with our final decision, you can choose to refer your
        complaint to the Communications & Internet Services Adjudication Scheme
        (CISAS), an independent and free dispute resolution scheme.
        <br />
        <br />
        <b>Here's how to contact them:</b>
        <br />
        <br />
        <b>Post</b>
        <br />
        100 St. Paul's Churchyard,
        <br />
        London EC4M 8BU
        <br />
        United Kingdom
        <br />
        <br />
        <b>Email</b>
        <br />
        <a href="mailto: cisas@cedr.com">cisas@cedr.com</a>
        <br />
        <br />
        <b>Online</b>
        <br />
        <a
          href="https://www.cedr-assist.com/consumer/cisas/overview/"
          target="_blank"
          rel="noreferrer"
        >
          cedr-assist.com/consumer/cisas/overview/
        </a>
        <br />
        <br />
        <b>Phone</b>
        <br />
        <u>020 7520 3814</u>
        <br />
        <br />
        CISAS may decide that your complaint isn’t something they’re able to
        deal with. But if that's the case, they’ll tell you and explain why.
        <br />
        <br />
        SMARTY is a trading name of Hutchison 3G UK Ltd. <br />
        Registered address: Vodafone House, The Connection, Newbury, Berkshire,
        RG14 2FN. <br />
        Registered in England & Wales | Registered company number: 03885486.
        <br />
        Authorised and regulated by the Financial Conduct Authority for Consumer
        Credit (reference number: 738979)
      </>
    </Accordion>
  )

  return isFullWidthBox ? (
    <ContentWrapper
      isFullWidth
      noPadding
      bgColor="UI/DarkGrey"
      className={classes.root}
    >
      <ContentWrapper>
        <AccordionContent />
      </ContentWrapper>
    </ContentWrapper>
  ) : (
    <ContentWrapper noPadding bgColor="UI/DarkGrey">
      <AccordionContent />
    </ContentWrapper>
  )
}

export default HowToComplain
